import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Dialog from '@material-ui/core/Dialog';

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrDatePicker from '../components/FrDatePicker'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrTable from '../components/FrTable'
import {colors} from '../utils/vars'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import { Hidden } from '@material-ui/core';

const swal = withReactContent(Swal)

function RegEncaminhamentos(props) {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authIntcc'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [data, setData] = useState({})
  const [dataDisponibilidades, setDataDisponibilidades] = useState([])
  const [showModalDisponibilidades, setShowModalDisponibilidades] = useState(false)
  const [updateType, setUpdateType] = useState(false)
  const [comboAtivo, setComboAtivo] = useState([{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }])
  const [enableEdit, setEnableEdit] = useState('N')

  const columnsDisp = [
    { id: 'NOME', numeric: false, label: 'Sede', align: 'left', Width: 100 },
    { id: 'DIA', numeric: false, label: 'Dia', align: 'left', Width: 100 },
    { id: 'HORARIO_INICIAL', numeric: false, label: 'Horário', align: 'left', Width: 100 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('encaminhamentos', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('encaminhamentos', 'Inclusao'))
      }


      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/encaminhamentos?pk_ecw=' + query.codigo+'&usu_logado='+auth.user).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            setData(r.data[0])
            api.get('/disponibilidades/pacientes?pk_pac=' + r.data[0].FK_PAC + '&usu_logado=' + auth.user).then(r => {
              console.log('entrou')
              setDataDisponibilidades(r.data)
              let auxValues = [...r.data]
              console.log(r.data)
              swal.close()
            })
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'descricao',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
        cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.host = window.location.href;
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/encaminhamentos/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/encaminhamentos/add', auxValues).then(r => {
                console.log(r.status)
                if (r.status === 200) {
                  swal.fire({
                    title: 'Registro Adicionado',
                    text: "O registro foi adicionado com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.history.back()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          swal.fire({
            title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
        cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    // auxValues[e.target.name] = e.target.value;
    switch (e.target.name) {
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };


  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>Visualização de Prontuários</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='100'
            value={data.NUMERO_PRONTUARIO || ''}
            onChange={handleChange}
            name="NUMERO_PRONTUARIO"
            id="NUMERO_PRONTUARIO"
            color="#389492"
            label="Nº Prontuário"
            variant="outlined"
            size="small"
            required
            style={{ width: 330 }}
          />
          
          <FrTextInput
            maxLength='100'
            value={data.TIPO_PRONTUARIO || ''}
            onChange={handleChange}
            name="TIPO_PRONTUARIO"
            id="TIPO_PRONTUARIO"
            color="#389492"
            label="Tipo Prontuário"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />
          
          <FrDatePicker
            value={(data.DATA_ENCAMINHAMENTO || '').split('T')[0]}
            name="DATA_ENCAMINHAMENTO"
            id="DATA_ENCAMINHAMENTO"
            color="#528b46"
            label="Período"
            variant="outlined"
            size="small"
            style={{ width: 190 }}

          />
            
          <FrTextInput
            maxLength='100'
            value={data.TERAPEUTA || ''}
            onChange={handleChange}
            name="TERAPEUTA"
            id="TERAPEUTA"
            color="#389492"
            label="Terapeuta"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.TERAPEUTA2 || ''}
            onChange={handleChange}
            name="TERAPEUTA2"
            id="TERAPEUTA2"
            color="#389492"
            label="Terapeuta 2"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />
           <FrTextInput
            maxLength='100'
            value={data.TRIADOR || ''}
            onChange={handleChange}
            name="TRIADOR"
            id="TRIADOR"
            color="#389492"
            label="Triador"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />
          <FrTextInput
            maxLength='100'
            value={data.SUPERVISOR || ''}
            onChange={handleChange}
            name="SUPERVISOR"
            id="SUPERVISOR"
            color="#389492"
            label="Supervisor"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />
          <FrTextInput
            maxLength='100'
            value={data.SUPLENTE || ''}
            onChange={handleChange}
            name="SUPLENTE"
            id="SUPLENTE"
            color="#389492"
            label="Suplente"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />
          
          <FrTextInput
            maxLength='100'
            value={data.PACIENTE || ''}
            onChange={handleChange}
            name="PACIENTE"
            id="PACIENTE"
            color="#389492"
            label="Paciente"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.IDADE || ''}
            onChange={handleChange}
            name="IDADE"
            id="IDADE"
            color="#389492"
            label="Idade"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.GENERO_TERAPEUTA || ''}
            onChange={handleChange}
            name="GENERO_TERAPEUTA"
            id="GENERO_TERAPEUTA"
            color="#389492"
            label="Gênero Terapeuta"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.SEDE_PREFERENCIAL || ''}
            onChange={handleChange}
            name="SEDE_PREFERENCIAL"
            id="SEDE_PREFERENCIAL"
            color="#389492"
            label="Sede Preferêncial"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <FrDatePicker
            value={(data.DATA_ABERTURA || '').split('T')[0]}
            name="DATA_ABERTURA"
            id="DATA_ABERTURA"
            color="#528b46"
            label="Data Abertura"
            variant="outlined"
            size="small"
            style={{ width: 190 }}

          />

          <FrTextInput
            maxLength='100'
            value={data.SEDE_PREFERENCIAL || ''}
            onChange={handleChange}
            name="SEDE_PREFERENCIAL"
            id="SEDE_PREFERENCIAL"
            color="#389492"
            label="Sede Preferêncial"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.OBS_TRIAGEM || ''}
            onChange={handleChange}
            name="OBS_TRIAGEM"
            id="OBS_TRIAGEM"
            color="#389492"
            label="Observações Triagem"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <br/>
          <p style={{textDecoration: 'underline', cursor: 'pointer', width: 100}} onClick={() => {setShowModalDisponibilidades(true)}}>Disponibilidades</p>


          


        </form>
        <div className="regButtonsDiv">
          {1==0 ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{1==0 ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
      <Dialog  aria-labelledby="simple-dialog-title" open={showModalDisponibilidades} fullWidth={true} maxWidth={'sm'}>
      <div style={{ padding: '20px', paddingTop: '40px', backgroundColor:'var(--cor-tema)'  }}>

        <div className="defaultHeader">

          <h3>Disponibilidades</h3>
        </div>
        <br />

            
          <FrTable 
            regName={'disponibilidades'} 
            columns={columnsDisp} 
            // searched={filtered} 
            columnToOrder={2} 
            ascDescOrder={'desc'} 
            codeName="PK_DIS" 
            page={'disp'} 
            data={dataDisponibilidades} 
            readOnly
            enableEdit={'N'} 
            uploadArquivos={'N'} 
            downloadArquivos={'N'} 
            enableDel={false} 
          />
              

          {/* <div style={{ display: 'flex', flex: 1, marginTop: '20px', flexDirection: 'column', alignItems: 'flex-start', backgroundColor:'var(--cor-tema)' }}>

           

            

          </div> */}
        </div>
        <div className="FrModalFooter">
          <div className="FrModalButtonsDiv" >
            {/* <button onClick={}> Confirmar </button> */}
            <button onClick={() => {setShowModalDisponibilidades(false)}}> Sair </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default RegEncaminhamentos;
